'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var setFrameworkInstance = function (lighthouseFramework) {
};

var RouteIds;
(function (RouteIds) {
    RouteIds["PayRulesEditor"] = "pay-rules-editor";
})(RouteIds || (RouteIds = {}));

var PayRulesEditor = function () {
    return React__namespace.createElement("div", null, "Hello world");
};

var routes = function () {
    return [
        {
            id: RouteIds.PayRulesEditor,
            route: '/pay-rules-editor',
            component: PayRulesEditor,
            restricted: true
        }
    ];
};

var PAY_RULES_EDITOR = {
	TITLE: {
		TARGET: "Pay Rules Editor",
		NOTE: "The title of the Pay Rules Editor page."
	}
};
var EnglishUS = {
	PAY_RULES_EDITOR: PAY_RULES_EDITOR
};

var module$1 = {
    setFrameworkInstance: setFrameworkInstance,
    getId: function () { return 'pay-rules-editor'; },
    getName: function () { return 'Pay Rules Editor Module'; },
    getRouteSpecifications: function () { return routes(); },
    getReducers: function () { return ({}); },
    setI18nInstance: function (instance) {
    },
    getI18nResources: function () { return ({
        'en-US': EnglishUS
    }); }
};

exports.Module = module$1;
//# sourceMappingURL=index.js.map
